'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { userBorrowPositionsQueryOptions } from '@/hooks/positions/userBorrowPositionsQuery';

/**
 * Borrow positions for the dashboard Borrow hero. It shares the positions table's query, so the
 * hero cards and the table make one request, and every position is included so totals and the
 * network selector cover the whole portfolio.
 */
export const useDashboardBorrowPositions = accountAddress => {
  const $ = _c(10);
  let t0;
  if ($[0] !== accountAddress) {
    t0 = userBorrowPositionsQueryOptions(accountAddress);
    $[0] = accountAddress;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      ...t0,
      refetchInterval: 10000
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data,
    isLoading,
    isError
  } = useQuery(t1);
  let t2;
  if ($[4] !== data?.items) {
    t2 = data?.items ?? [];
    $[4] = data?.items;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const borrowPositions = t2;
  const t3 = isError || data?.partial === true && borrowPositions.length === 0;
  let t4;
  if ($[6] !== borrowPositions || $[7] !== isLoading || $[8] !== t3) {
    t4 = {
      borrowPositions,
      loading: isLoading,
      isError: t3
    };
    $[6] = borrowPositions;
    $[7] = isLoading;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};